import { z } from 'zod';

export const RESULT_PREFIX = 'NOCONFLICT_RESULT ';

/**
 * The JSON the sandbox process prints as its final stdout line, prefixed by RESULT_PREFIX. A `dummy` run's success
 * names the `summary.md` it pushed and the files in its table; a `script-entities` run's has neither (its result is
 * the rows it wrote).
 */
export const sandboxResultSchema = z.discriminatedUnion('ok', [
  z.object({
    ok: z.literal(true),
    summaryPath: z.string().min(1).optional(),
    files: z.number().int().nonnegative().optional(),
  }),
  z.object({ ok: z.literal(false), error: z.string() }),
]);
export type SandboxResult = z.infer<typeof sandboxResultSchema>;

/** Extracts the final NOCONFLICT_RESULT line from process stdout. */
export function parseSandboxOutput(stdout: string): SandboxResult {
  const line = stdout
    .split('\n')
    .filter((l) => l.startsWith(RESULT_PREFIX))
    .at(-1);
  if (!line) return { ok: false, error: 'no result line in sandbox output' };
  try {
    return sandboxResultSchema.parse(JSON.parse(line.slice(RESULT_PREFIX.length)));
  } catch (e) {
    return { ok: false, error: `bad result line: ${e instanceof Error ? e.message : String(e)}` };
  }
}
